// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"ChangeDueDateDialog_modalTitle_3VtSW","datepicker":"ChangeDueDateDialog_datepicker_8tyD9","spinAround":"ChangeDueDateDialog_spinAround_1rgrH"};